// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

import { PalettesProps } from "@ant-design/colors";

const Theme = (colors: PalettesProps) => {
  const { blue, red, gold, cyan, green, grey } = colors;
  const greyAxiss = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16],
  };
  const dark = "#28243d";
  const contrastText = "#fff";

  return {
    primary: {
      lighter: blue[0],
      100: blue[1],
      200: blue[2],
      light: blue[3],
      400: blue[4],
      main: blue[5],
      dark: blue[6],
      700: blue[7],
      darker: blue[8],
      900: blue[9],
      contrastText,
    },
    secondary: {
      lighter: greyAxiss[100],
      100: greyAxiss[100],
      200: greyAxiss[200],
      light: greyAxiss[300],
      400: greyAxiss[400],
      main: greyAxiss[500],
      600: greyAxiss[600],
      dark: greyAxiss[700],
      800: greyAxiss[800],
      darker: greyAxiss[900],
      A100: greyAxiss[0],
      A200: greyAxiss.A400,
      A300: greyAxiss.A700,
      contrastText: greyAxiss[0],
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText,
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyAxiss[100],
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText,
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText,
    },
    grey: greyAxiss,
    dark,
  };
};

export default Theme;
